(ns frontend.ui.component.lp-portal.modal.edit-modals.events
  (:require
    [common.util :as cu]))

(defn remove-column!
  [state index colors?]
  (let [columns (:columns @state)
        data (:data @state)
        cell-data-types (:cell-data-types @state)
        cell-styles (:cell-styles @state)
        colors (:series-colors @state)
        excel-configured-colors (:configured-colors @state)
        chart-key (:chart-key @state)
        one-column? (->> @state
                         :columns
                         (count)
                         (= 1))]
    (when-not one-column?
      (reset! state
              (cond-> {}
                (not-empty cell-data-types)
                (assoc :cell-data-types
                       (->> cell-data-types
                            (mapv (fn [row-data-types]
                                    (cu/vec-remove index row-data-types)))))
                excel-configured-colors
                (assoc :configured-colors excel-configured-colors)
                chart-key
                (assoc :chart-key chart-key)
                (not-empty cell-styles)
                (assoc :cell-styles
                       (->> cell-styles
                            (mapv (fn [row-styles]
                                    (cu/vec-remove index row-styles)))))
                colors?
                (assoc :series-colors (cu/vec-remove index colors))
                true                                  ;;Always has columns and data
                (assoc
                 :columns (cu/vec-remove index (vec columns))
                 :data (->> data
                            (mapv (fn [row-data]
                                    (cu/vec-remove (inc index) row-data))))))))))

(defn add-column-to-index!
  [state index can-edit-colors?]
  (let [columns (:columns @state)
        data (:data @state)
        cell-data-types (:cell-data-types @state)
        cell-styles (:cell-styles @state)
        editable-colors (:series-colors @state)
        excel-configured-colors (:configured-colors @state)
        chart-key (:chart-key @state)]
    (reset! state
            (cond-> {}
              (not-empty cell-data-types)
              (assoc :cell-data-types
                     (->> cell-data-types
                          (mapv (fn [row-data-types]
                                  (cu/vec-insert index :string row-data-types)))))
              excel-configured-colors
              (assoc :configured-colors excel-configured-colors)
              chart-key
              (assoc :chart-key chart-key)
              (not-empty cell-styles)
              (assoc :cell-styles
                     (->> cell-styles
                          (mapv (fn [row-styles]
                                  (cu/vec-insert index nil row-styles)))))
              can-edit-colors?
              (assoc :series-colors (cu/vec-insert index "" editable-colors))
              true                                    ;;Always has columns and data
              (assoc
               :columns (cu/vec-insert index "" columns)
               :data (->> data
                          (mapv (fn [row-data]
                                  (let [row-data (if (= (count row-data) 1) ;;When some row data has only the row label
                                                   (vec (cons (first row-data) (repeat (count columns) nil)))
                                                   row-data)]
                                    (cu/vec-insert (+ index 1) nil row-data))))))))))

(defn add-column!
  [state to-end?]
  (swap! state update-in
         [:columns]
         (fn [cols]
           (if to-end?
             (vec (conj cols ""))
             (vec (cons "" cols)))))
  (swap! state update-in
         [:data]
         (fn [data]
           (->> data
                (mapv (fn [row-data]
                        (if to-end?
                          (vec (conj row-data ""))
                          (vec (cu/vec-insert 1 "" row-data)))))))))

(defn add-row-to-index!
  [state index]
  (let [columns (:columns @state)
        data (:data @state)
        cell-data-types (:cell-data-types @state)
        cell-styles (:cell-styles @state)
        highlight-figures? (:highlight-figures? @state)]
    (reset! state
            (cond-> {}
              (not-empty cell-data-types)
              (assoc :cell-data-types
                     (->> cell-data-types
                          (mapv (fn [row-data-types]
                                  (cu/vec-insert index :string row-data-types))))) ;;TODO dynamic type
              (not-empty cell-styles)
              (assoc :cell-styles
                     (cu/vec-insert index (vec (repeat (inc (count (:columns @state))) nil)) data))
              highlight-figures?
              (assoc :highlight-figures? true)
              true
              (assoc
               :columns columns
               :data (cu/vec-insert index (vec (repeat 
                                                (if highlight-figures?
                                                  (count (:columns @state))
                                                  (inc (count (:columns @state)))) nil)) data))))))

(defn add-row!
  [state]
  (swap! state update-in
         [:data]
         (fn [data]
           (conj data (vec (repeat (+ 1 (count (:columns @state))) nil))))))

(defn remove-row!
  [state row-idx]
  (when-not (->> @state
                 :data
                 (count)
                 (= 1))
    (swap! state update-in
           [:data]
           (fn [data]
             (cu/vec-remove row-idx data)))))

(defn update-heading!
  [state index new-value]
  (swap! state assoc-in [:columns index] new-value)
  (swap! state assoc-in [:original-data :headers 0 :cols index] new-value)) ;;TODO refactor

(defn update-color!
  [state index new-value]
  (swap! state assoc-in [:series-colors index] new-value))

(defn update-value!
  [state row-index col-index new-value]
  (swap! state assoc-in [:data row-index col-index] new-value))

(defn update-axis-config!
  [state row-index col-index new-value]
  (swap! state assoc-in [:y-axis-config row-index col-index] new-value))

(defn update-tooltip-config!
  [state row-index col-index new-value]
  (swap! state assoc-in [:tooltip-config row-index col-index] new-value))
